import { createSlice } from '@reduxjs/toolkit';

const textureDetailsModal = createSlice({
  name: 'textureDetailsModal',
  initialState: {
    data: null,
    materialData: null
  },
  reducers: {
    show: (state, { payload }) => {
      state.data = payload
    },
    close: (state) => {
      state.data = null;
      state.materialData = null;
    },
    generateContentShowModal: (state, { payload }) => {
      state.generateContentModal = payload
    },
    closeGenerateContentShowModal: (state) => {
      state.generateContentModal = null;
    },
    showMaterialInfo: (state, { payload }) => {
      state.materialData = payload;
    }
  },
});

export const textureDetailsModalActions = textureDetailsModal.actions;
export const textureDetailsModalReducer = textureDetailsModal.reducer;
export default textureDetailsModalReducer;

export const selectTextureDetailsModalData = (state) => state.textureDetailsModal.data;
export const selectGenerateContentModalData = (state) => state.textureDetailsModal.generateContentModal;

export const selectMaterialDetailsModalData = (state) => state.textureDetailsModal.materialData;